import React, { useState } from 'react'
import { Box, IcoMoon, KeyboardArrowDownIcon } from '@usap/uicomponents'
import { createRedirectLinkFitment } from '@usap/core'
import { TextWithPointer } from '../StyledCSS'
import Label from './Label'
import PopUpLayer from '../PopUpLayer'
import FitmentTable from './FitmentTable'

const styleManager = {
  paddingLeft: { left: 'small' },
  marginBottom: { bottom: 'small' },
  textDecoration: { textDecoration: 'underline' },
  fxSize: { large: '14px', other: '12px' },
  linkWrapper: { marginTop: 8 },
  changeText: { paddingLeft: 16, textDecoration: 'underline' },
}

export default function CheckFitmentAnchorContainer({
  labelContainerWidth,
  labelMargin,
  firstLabelText,
  selectedVehicle,
  vehicleString,
  addVehicleTrigger,
  orderItemId,
  cart: isFromCart,
  checkout: isFromCheckout,
  fitNotes,
  history,
  part,
}) {
  const [openFitment, setOpenFitment] = useState(false)

  const handleFitmentClick = () => {
    if (isFromCart || isFromCheckout) return setOpenFitment(true)
    const elem = document.getElementById('vehicleFitDetails')
    if (elem) elem.scrollIntoView({ behavior: 'smooth' })
    return ''
  }

  const vehicleChangable = addVehicleTrigger instanceof Function

  const redirectToSearch = () => {
    const url = createRedirectLinkFitment(part, selectedVehicle)
    history.push(url)
  }

  const showVehicleName = Boolean(selectedVehicle && (vehicleChangable || isFromCheckout))

  return (
    <Box
      pad={styleManager.paddingLeft}
      align="start"
      justify="center"
      {...labelContainerWidth}
    >
      <PopUpLayer
        flag={openFitment}
        records={fitNotes}
        redirectToSearch={redirectToSearch}
        isFromCheckout={isFromCheckout}
        closePopUp={setOpenFitment}
        PopUpComponent={FitmentTable}
      />
      <Label {...labelMargin}>{firstLabelText}</Label>
      {showVehicleName && (
        <Label size="small">{vehicleString}</Label>
      )}

      <Box direction="row" justify="center" align="center" style={styleManager.linkWrapper}>
        <Box direction="row" justify="center" align="center">
          <TextWithPointer
            fxSize={styleManager.fxSize}
            color="blueLink"
            weight={700}
            style={styleManager.textDecoration}
            onClick={handleFitmentClick}
          >
            See Fitment Info
          </TextWithPointer>
          {!isFromCart && <IcoMoon icon={KeyboardArrowDownIcon} color="#05629b" size="16px" />}
        </Box>
        {vehicleChangable && (
          <TextWithPointer
            fxSize={styleManager.fxSize}
            color="blueLink"
            weight={700}
            style={styleManager.changeText}
            onClick={() => addVehicleTrigger(orderItemId, 'change')}
          >
            Change Vehicle
          </TextWithPointer>
        )}
      </Box>
    </Box>
  )
}
